/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("digiexam").
controller("SettingsController", function SettingsController(
	$scope,
	$timeout,
	$window,
	faults,
	dxLocalize,
	DxUser,
	UIStateManager,
	dxDialog,
	dxSession,
	dxEvent,
	dxLanguageCookieSetter,
	dxAngularConstantHelper
) {
	"use strict";

	$scope.state = new UIStateManager("loading");
	$scope.user = new DxUser();

	var DX_EVENT_NAME = dxAngularConstantHelper.DX_EVENT_NAME;

	dxEvent.create(DX_EVENT_NAME.PageviewUserSettings);

	// Extend for now. The user.load method doesn't update the user fully
	angular.extend($scope.user, dxSession.getUser());

	var promise = $scope.user.load();

	promise.then(function success() {
		$scope.state.set("default");
		$scope.checkFirstname();
		return $scope.checkLastname();
	}, function failed(response) {
		return $window.console.log("error response: ", response);
	});

	$scope.firstnameValidation = {
		display: false,
		warning: false,
		error: false,
		success: false,
		message: dxLocalize.get("RequiredField"),
	};

	$scope.lastnameValidation = {
		display: false,
		warning: false,
		error: false,
		success: false,
		message: dxLocalize.get("RequiredField"),
	};

	$scope.oldPasswordValidation = {
		display: false,
		warning: false,
		error: false,
		success: false,
		message: dxLocalize.get("RequiredField"),
	};

	$scope.newPasswordValidation = {
		display: false,
		warning: false,
		error: false,
		success: false,
		message: dxLocalize.get("RequiredField"),
	};

	$scope.confirmNewPasswordValidation = {
		display: false,
		warning: false,
		error: false,
		success: false,
		message: dxLocalize.get("RequiredField"),
	};

	$scope.passwords = {};
	$scope.passwords.old = "";
	$scope.passwords.new = "";
	$scope.passwords.confirm = "";
	$scope.showDetailsSavedMessage = false;
	$scope.showPasswordSavedMessage = false;

	$scope.languages = [
		{
			key: "en",
			name: "English",
		}, {
			key: "sv",
			name: "Svenska",
		}, {
			key: "fi",
			name: "Suomi",
		},
	];

	$scope.lang = {
		selected: dxLocalize.getLanguage(),
	};

	$scope.$watch("lang.selected", function watchLangSelected(newValue, oldValue) {
		if (newValue === oldValue) {
			return;
		}

		dxLocalize.setLanguage($scope.lang.selected);
		dxLanguageCookieSetter($scope.lang.selected);
	});

	function setValidationState(validationSet, validationState, message) { // eslint-disable-line consistent-return
		validationSet.message = message;
		switch (validationState) {
			case "warning":
				validationSet.warning = true;
				return validationSet.error = validationSet.success = false; // eslint-disable-line no-return-assign
			case "error":
				validationSet.error = true;
				return validationSet.warning = validationSet.success = false; // eslint-disable-line no-return-assign
			case "success":
				validationSet.success = true;
				return validationSet.warning = validationSet.error = false; // eslint-disable-line no-return-assign
			default:
				break;
		}
	}

	$scope.checkFirstname = function checkFirstname() {
		$scope.firstnameValidation.display = true;
		if ($scope.user.firstName.length === 0) {
			return setValidationState($scope.firstnameValidation, "warning", dxLocalize.get("RequiredField"));
		} else if ($scope.user.firstName.length < 2) {
			return setValidationState($scope.firstnameValidation, "warning", dxLocalize.get("MustBeLongerThan1Char"));
		}

		return setValidationState($scope.firstnameValidation, "success", "");
	};

	$scope.checkLastname = function checkLastname() {
		$scope.lastnameValidation.display = true;
		if ($scope.user.lastName.length === 0) {
			return setValidationState($scope.lastnameValidation, "warning", dxLocalize.get("RequiredField"));
		} else if ($scope.user.lastName.length < 2) {
			return setValidationState($scope.lastnameValidation, "warning", dxLocalize.get("MustBeLongerThan1Char"));
		}

		return setValidationState($scope.lastnameValidation, "success", "");
	};

	$scope.checkOldPassword = function checkOldPassword() {
		$scope.oldPasswordValidation.display = true;
		if ($scope.passwords.old.length === 0) {
			return setValidationState($scope.oldPasswordValidation, "warning", dxLocalize.get("RequiredField"));
		}

		return setValidationState($scope.oldPasswordValidation, "success", "");
	};

	$scope.checkNewPassword = function checkNewPassword() { // eslint-disable-line consistent-return
		$scope.newPasswordValidation.display = true;

		if ($scope.passwords.new.length === 0) {
			setValidationState($scope.newPasswordValidation, "warning", dxLocalize.get("RequiredField"));
		} else if ($scope.passwords.new.length < 8) {
			setValidationState($scope.newPasswordValidation, "warning", dxLocalize.get("MustBeLongerThan5Chars"));
		} else if ($scope.passwords.new.length > 100) {
			setValidationState($scope.newPasswordValidation, "warning", dxLocalize.get("PasswordTooLong"));
		} else {
			setValidationState($scope.newPasswordValidation, "success", "");
		}

		var whiteSpaceRegex = /\s+/;
		if (whiteSpaceRegex.test($scope.passwords.new)) {
			return setValidationState($scope.newPasswordValidation, "error", dxLocalize.get("PasswordWhitespace"));
		}

		if ($scope.oldPasswordValidation.display && $scope.passwords.old === $scope.passwords.new) {
			return setValidationState($scope.newPasswordValidation, "error", dxLocalize.get("PasswordCanNotBeOld"));
		} else if ($scope.confirmNewPasswordValidation.display && $scope.passwords.new !== $scope.passwords.confirm) {
			return setValidationState($scope.confirmNewPasswordValidation, "warning", dxLocalize.get("PasswordsAreNotAMatch"));
		} else if ($scope.confirmNewPasswordValidation.display && $scope.passwords.new === $scope.passwords.confirm) {
			return setValidationState($scope.confirmNewPasswordValidation, "success", "");
		}
	};
	$scope.checkConfirmNewPassword = function checkConfirmNewPassword() {
		$scope.confirmNewPasswordValidation.display = true;
		if ($scope.passwords.confirm.length === 0) {
			return setValidationState($scope.confirmNewPasswordValidation, "warning", dxLocalize.get("RequiredField"));
		} else if ($scope.passwords.confirm.length < 8) {
			return setValidationState($scope.confirmNewPasswordValidation, "warning", dxLocalize.get("MustBeLongerThan5Chars"));
		} else if ($scope.passwords.confirm.length > 100) {
			return setValidationState($scope.confirmNewPasswordValidation, "warning", dxLocalize.get("PasswordTooLong"));
		} else if ($scope.passwords.new !== $scope.passwords.confirm) {
			return setValidationState($scope.confirmNewPasswordValidation, "warning", dxLocalize.get("PasswordsAreNotAMatch"));
		}

		var whiteSpaceRegex = /\s+/;
		if (whiteSpaceRegex.test($scope.passwords.confirm)) {
			return setValidationState($scope.confirmNewPasswordValidation, "error", dxLocalize.get("PasswordWhitespace"));
		}

		return setValidationState($scope.confirmNewPasswordValidation, "success", "");
	};

	$scope.canUpdatePassword = function canUpdatePassword() {
		return $scope.oldPasswordValidation.success &&
			$scope.newPasswordValidation.success &&
			$scope.confirmNewPasswordValidation.success &&
			$scope.state.isnt("savingpassword");
	};

	$scope.canUpdateDetails = function canUpdateDetails() {
		return $scope.firstnameValidation.success &&
			$scope.lastnameValidation.success &&
			$scope.state.isnt("savingdetails");
	};

	var showPasswordSavedMessagePromise = 0;
	$scope.updatePassword = function updatePassword() {
		$scope.state.set("savingpassword");
		$scope.showPasswordSavedMessage = false;
		$timeout.cancel(showPasswordSavedMessagePromise);

		promise = $scope.user.changePassword($scope.passwords.old, $scope.passwords.new);

		return promise.then(function success(response) { // eslint-disable-line consistent-return
			$scope.state.set("default");
			if (response.faults == null) { // eslint-disable-line eqeqeq, no-eq-null
				$scope.showPasswordSavedMessage = true;
				$scope.passwords.old = "";
				$scope.passwords.new = "";
				$scope.passwords.confirm = "";
				showPasswordSavedMessagePromise = $timeout(function timeoutCallback() {
					$scope.showPasswordSavedMessage = false;
				}, 2000);
			} else if (response.faults.indexOf(faults.INVALID_CREDENTIALS) >= 0) {
				return setValidationState($scope.oldPasswordValidation, "error", dxLocalize.get("WrongPassword"));
			} else if (response.faults.indexOf(faults.PASSWORD_COMMON) >= 0) {
				return setValidationState($scope.newPasswordValidation, "error", dxLocalize.get("PasswordCommon"));
			} else if (response.faults.indexOf(faults.PASSWORD_HAS_WHITESPACE) >= 0) {
				return setValidationState($scope.newPasswordValidation, "error", dxLocalize.get("PasswordWhitespace"));
			}
		});
	};

	var showDetailsSavedMessagePromise = 0;
	$scope.updateDetails = function updateDetails() {
		$scope.state.set("savingdetails");
		$scope.showDetailsSavedMessage = false;
		$timeout.cancel(showDetailsSavedMessagePromise);

		promise = $scope.user.update();

		return promise.then(function success(response) {
			$scope.state.set("default");
			if (response.faults == null) { // eslint-disable-line eqeqeq, no-eq-null
				$scope.showDetailsSavedMessage = true;
				showDetailsSavedMessagePromise = $timeout(function timeoutCallback() {
					$scope.showDetailsSavedMessage = false;
				}, 2000);
			} else {
				dxDialog.alert({
					title: dxLocalize.get("UnknownError"),
					body: dxLocalize.get("UnknownError"),
					acceptText: dxLocalize.get("Ok"),
				});
			}
		});
	};
});
